import { render, staticRenderFns } from "./OrderViewDialog.vue?vue&type=template&id=7561fdf5&scoped=true"
import script from "./OrderViewDialog.vue?vue&type=script&lang=js"
export * from "./OrderViewDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderViewDialog.vue?vue&type=style&index=0&id=7561fdf5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7561fdf5",
  null
  
)

export default component.exports